import { getData } from '../../services/requestService';
import { createAsyncThunkWithCustomErrorHandling } from '../helpers';

export const fetchConfiguration = createAsyncThunkWithCustomErrorHandling('configuraiton', async () => {
  const data = await getData('/configuration', '');

  return data;
});
